import { IdeaOfTheWeekType, NewsFeedBodyType, NewsFeedType, NoticeBoardType } from "@robotical/analytics-gatherer";
import defaultStyles from "./traverseBodyDefaultStyles.module.css";
// export type NewsFeedType = {
//     title: string;
//     body: NewsFeedBodyType;
//     timestamp: string;
// };


// export type NewsFeedBodyType = {
//     [itemKey: string]: {
//         text?: string;
//         link?: string;
//         type: "paragraph" | "img" | "title";
//         position: number;
//     };
// };

const traverseBody = (newsFeedData: NewsFeedType | IdeaOfTheWeekType | NoticeBoardType) => {
    const newsFeedBody = newsFeedData.body;
    const newsFeedBodyArray = Object.values(newsFeedBody);
    const newsFeedBodyArraySorted = newsFeedBodyArray.sort((a, b) => a.position - b.position);
    return newsFeedBodyArraySorted;
};

export const renderBody = (newsFeedData: NewsFeedType | IdeaOfTheWeekType | NoticeBoardType, styles: any) => {
    const bodyArray = traverseBody(newsFeedData);
    return bodyArray.map((bodyItem, bodyItemIdx) => {
        if (bodyItem.type === "title") {
            return <div key={bodyItemIdx} className={styles.contentTitle || defaultStyles.contentTitle}>{bodyItem.text}</div>;
        } else if (bodyItem.type === "paragraph") {
            return <div key={bodyItemIdx} className={styles.contentParagraph || defaultStyles.contentParagraph}>{bodyItem.text}</div>;
        } else if (bodyItem.type === "img") {
            return <img className={styles.contentImg || defaultStyles.contentImg} key={bodyItemIdx} src={bodyItem.link} alt={bodyItem.text} />;
        } else if (bodyItem.type === "bulletList") {
            const listItems = bodyItem.text?.split("==>") || [];
            return (
                <ul key={bodyItemIdx} className={styles.contentBulletList || defaultStyles.contentBulletList}>
                    {listItems.map((listItem, listItemIdx) => (
                        <li key={listItemIdx} className={styles.contentBulletListItem || defaultStyles.contentBulletListItem}>{listItem}</li>
                    ))}
                </ul>
            );
        } else if (bodyItem.type === "subtitle") {
            return <div key={bodyItemIdx} className={styles.contentSubtitle || defaultStyles.contentSubtitle}>{bodyItem.text}</div>;
        }
    });
}